"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("rect", { height: "10", rx: "2", ry: "2", width: "10", x: "4", y: "6" }),
  React.createElement("rect", { height: "10", rx: "2", ry: "2", width: "10", x: "4", y: "20" }),
  React.createElement("rect", { height: "10", rx: "2", ry: "2", width: "10", x: "4", y: "34" }),
  React.createElement("rect", { height: "6", rx: "1", ry: "1", width: "24", x: "18", y: "8" }),
  React.createElement("rect", { height: "6", rx: "1", ry: "1", width: "24", x: "18", y: "22" }),
  React.createElement("rect", { height: "6", rx: "1", ry: "1", width: "24", x: "18", y: "36" })
);

